import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iConfirmActiveUserState {
    email: string;
    isLoading: boolean;
    response: any;
    message: string;
}

const initialState: iConfirmActiveUserState = {
    email: '',
    isLoading: false,
    response: [],
    message: ""
}

export const postConfirmActiveUserAPI = createAsyncThunk(
    'POST_CONFIRM_ACTIVE_USER',
    async (user: { email: string }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/auth/confirm-user/'

            const response = await axiosInstance.patch(
                `${djangoEndpoint}${pathParam}`,
                {
                    email: user.email,
                },
                {
                    withCredentials: true,
                }
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

const confirmActiveUserSlice = createSlice({
    name: 'confirmActiveUser',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postConfirmActiveUserAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(postConfirmActiveUserAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(postConfirmActiveUserAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.email = '';
                state.response = action.payload;
            });
    }
});

export default confirmActiveUserSlice.reducer;